import Swiper, {Navigation, Pagination} from 'swiper';

Swiper.use([Navigation, Pagination]);


/**
 * Flurry jQuery Plugin
 *
 * Flurry is an easy-to-use animated snow plugin for jQuery. It takes advantage
 * of CSS transforms, CSS transitions and requestAnimationFrame to provide
 * smooth animation for modern browsers. Props to Jonathan Nicol @f6design
 * for boilerplate code
 * (see http://jonathannicol.com/blog/2012/05/06/a-jquery-plugin-boilerplate/)
 *
 * @link      https://github.com/joshmcrty/Flurry
 * @version   1.1.0
 * @author    Josh McCarty <josh@joshmccarty.com>
 * @copyright 2016 Josh McCarty
 * @license   https://github.com/joshmcrty/Flurry/blob/master/LICENSE GPLv2
 */
//!function(n,e){function t(n,e){function t(){var o=(new Date).getTime(),r=o-a;r>=e&&(n.call(),a=(new Date).getTime()),i.value=window.requestAnimationFrame(t)}var a=(new Date).getTime(),i=new Object;return i.value=window.requestAnimationFrame(t),i}function a(n){window.cancelAnimationFrame?window.cancelAnimationFrame(n.value):window.webkitCancelAnimationFrame?window.webkitCancelAnimationFrame(n.value):window.webkitCancelRequestAnimationFrame?window.webkitCancelRequestAnimationFrame(n.value):window.mozCancelRequestAnimationFrame?window.mozCancelRequestAnimationFrame(n.value):window.oCancelRequestAnimationFrame?window.oCancelRequestAnimationFrame(n.value):window.msCancelRequestAnimationFrame?window.msCancelRequestAnimationFrame(n.value):clearInterval(n)}function i(){var n=document.body||document.documentElement,t=n.style,a=t.transition!==e||t.WebkitTransition!==e||t.MozTransition!==e||t.MsTransition!==e||t.OTransition!==e;return a}function o(n,e){return Math.floor(Math.random()*(e-n+1)+n)}function r(e,t,a){var r=1===e.character.length?e.character:e.character.charAt(Math.round(o(0,e.character.length-1))),s=o(-Math.abs(e.wind),a+Math.abs(e.wind)),c=s+o(e.wind-e.windVariance,e.wind+e.windVariance),l=o(e.small,e.large),u=e.speed/((o(1.2*l,.8*l)-e.small)/(e.large-e.small)+.5),m=e.height-l,d=o(e.rotation-e.rotationVariance,e.rotation+e.rotationVariance),w=Array.isArray(e.color)?e.color[Math.floor(Math.random()*e.color.length)]:e.color,f={transform:"translateX("+c+"px) translateY("+m+"px) rotateZ("+d+"deg)",opacity:0},h=n("<span></span>");h.html(r).css({color:e.blur&&l<(e.large+e.small)/2?"transparent":w,"text-shadow":e.blur&&l<(e.large+e.small)/2?"0 0 1px "+w:"none",display:"inline-block","line-height":1,margin:0,padding:"2px","pointer-events":"none","font-size":l+"px",opacity:e.startTransparency,position:"absolute",top:"-"+1.2*e.large+"px",transform:"translateX("+s+"px) translateY(0px) rotateZ("+e.startRotation+"deg)",transition:"transform "+u/1e3+"s linear, opacity "+u/1e3+"s "+e.opacityEasing,"z-index":e.zIndex}).appendTo(t),i?(h.on("transitionend.flurry",function(e){n(e.target).remove()}),window.requestAnimationFrame(function(){h.css(f)})):h.animate(f,u,"linear",function(){n(this).remove()})}function s(i,o){function s(){o.useRelative===!0&&"static"===f.css("position")&&f.css({position:"relative"});var e=n(document.createElement("div")).addClass("flurry-container").css({margin:0,padding:0,position:"absolute",top:0,right:0,left:0,height:o.height,overflow:o.overflow,"pointer-events":"none"}).prependTo(f),a=e.width();n(window).resize(function(){a=e.width()}),d.flakeInterval=t(function(){r(o,e,a)},o.frequency),m("onInit")}function l(n,e){return e?void(o[n]=parseInt(e)||e):o[n]}function u(){f.each(function(){var e=n(this);a(d.flakeInterval),e.find(".flurry-container").remove(),m("onDestroy"),e.removeData("plugin_"+c)})}function m(n){o[n]!==e&&o[n].call(w)}var d=this,w=i,f=n(i);return o=n.extend({height:f.height()>200?200:f.height(),useRelative:f.is("body")?!1:!0},n.fn[c].defaults,o),n.each(o,function(n,e){parseInt(e)&&(o[n]=parseInt(e))}),s(),{option:l,destroy:u}}!function(){for(var n=0,e=["ms","moz","webkit","o"],t=0;t<e.length&&!window.requestAnimationFrame;++t)window.requestAnimationFrame=window[e[t]+"RequestAnimationFrame"],window.cancelAnimationFrame=window[e[t]+"CancelAnimationFrame"]||window[e[t]+"CancelRequestAnimationFrame"];window.requestAnimationFrame||(window.requestAnimationFrame=function(e,t){var a=(new Date).getTime(),i=Math.max(0,16-Math.abs(a-n)),o=window.setTimeout(function(){e(a+i)},i);return n=a+i,o}),window.cancelAnimationFrame||(window.cancelAnimationFrame=function(n){clearTimeout(n)})}();var c="flurry";n.fn[c]=function(t){if("string"==typeof arguments[0]){var a,i=arguments[0],o=Array.prototype.slice.call(arguments,1);return this.each(function(){if(!n.data(this,"plugin_"+c)||"function"!=typeof n.data(this,"plugin_"+c)[i])throw new Error("Method "+i+" does not exist on jQuery."+c);a=n.data(this,"plugin_"+c)[i].apply(this,o)}),a!==e?a:this}return"object"!=typeof t&&t?void 0:this.each(function(){n.data(this,"plugin_"+c)||n.data(this,"plugin_"+c,new s(this,t))})},n.fn[c].defaults={onInit:function(){},onDestroy:function(){},character:"❄",color:"white",frequency:100,speed:3e3,small:8,large:28,wind:40,windVariance:20,rotation:90,rotationVariance:180,startRotation:0,startOpacity:1,endOpacity:0,opacityEasing:"cubic-bezier(1,.3,.6,.74)",blur:!0,overflow:"hidden",zIndex:9999}}(jQuery);

$(document).ready(function () {

  // снег

  // $(document).ready(function () {
  //   $("body").flurry();
  // });


  // фиксим модальное окно через окно
  $(document).on('hidden.bs.modal', function (event) {
    if ($('.modal:visible').length) {
      $('body').addClass('modal-open');
    }
  });

  // if ($(".hero__carousel").length) {
  //   // init of HERO carousel
  //   const swiper = new Swiper('.hero__carousel', {
  //     loop: true,
  //     simulateTouch: false,
  //     speed: 800,
  //     pagination: {
  //       el: '.hero__carousel-pagination',
  //       type: 'bullets',
  //     },
  //     breakpoints: {
  //       768: {
  //         pagination: false
  //       },
  //     },
  //     navigation: {
  //       nextEl: '.hero__carousel-btn--next',
  //       prevEl: '.hero__carousel-btn--prev',
  //     },
  //   });
  // }

  // SLIDER на главной
  let slide = 0
  let slide_2 = 1
  let slide_3 = 2
  let $hero__slide = $('.hero__slides .hero__slide')
  let $hero__slide_2 = $('.hero__2 .hero__slide-small')
  let $hero__slide_3 = $('.hero__3 .hero__slide-small')
  let slide_num = $hero__slide.length
  $hero__slide.hide().eq(slide).show()
  $hero__slide_2.hide().eq(slide_2).show()
  $hero__slide_3.hide().eq(slide_3).show()

  $('.hero__carousel-btn--next').on('click', function () {
    clearInterval(slide_play);
    next_slide();
  });

  let slide_play = setInterval(next_slide, 5000)

  function next_slide() {
    $hero__slide.eq(slide).hide();
    if (slide === slide_num - 1) {
      slide = 0;
    } else {
      slide = slide + 1;
    }
    $hero__slide.eq(slide).show();

    $hero__slide_2.eq(slide_2).hide();
    if (slide_2 === slide_num - 1) {
      slide_2 = 0;
    } else {
      slide_2 = slide_2 + 1;
    }
    $hero__slide_2.eq(slide_2).show();

    $hero__slide_3.eq(slide_3).hide();
    if (slide_3 === slide_num - 1) {
      slide_3 = 0;
    } else {
      slide_3 = slide_3 + 1;
    }
    $hero__slide_3.eq(slide_3).show();
  }

  $('.hero__carousel-btn--prev').on('click', function () {
    clearInterval(slide_play);
    $hero__slide.eq(slide).hide();
    if (slide === 0) {
      slide = slide_num - 1;
    } else {
      slide = slide - 1;
    }
    $hero__slide.eq(slide).show();

    $hero__slide_2.eq(slide_2).hide();
    if (slide_2 === 0) {
      slide_2 = slide_num - 1;
    } else {
      slide_2 = slide_2 - 1;
    }
    $hero__slide_2.eq(slide_2).show();

    $hero__slide_3.eq(slide_3).hide();
    if (slide_3 === 0) {
      slide_3 = slide_num - 1;
    } else {
      slide_3 = slide_3 - 1;
    }
    $hero__slide_3.eq(slide_3).show();
  });

  if ($(".shop-types__list").length) {

    // init of Shops carousel
    const swiper5 = new Swiper('.shop-types__list', {
      loop: true,
      slidesPerView: 'auto',
      spaceBetween: 10,
      centeredSlides: true,
      simulateTouch: false,
      speed: 800,
      init: false,
      navigation: {
        nextEl: '.shop-types__btn--next',
        prevEl: '.shop-types__btn--prev',
      },
      pagination: {
        el: '.shop-types__pagination',
        type: 'bullets',
      },
      breakpoints: {
        479: {
          centeredSlides: false,
          slidesPerView: 2,
        },
        575: {
          centeredSlides: false,
          slidesPerView: 3,
        },
      }
    });

    function initSlider() {
      if ($(window).width() < 992) {
        swiper5.init();
      }
    }

    $(window).on('resize', initSlider)

    initSlider();
  }

  if ($(".restaurants__carousel").length) {
    // init of Restaurants carousel
    const swiper2 = new Swiper('.restaurants__carousel', {
      loop: true,
      slidesPerView: 'auto',
      spaceBetween: 10,
      simulateTouch: false,
      speed: 800,
      navigation: {
        nextEl: '.restaurants__carousel-btn--next',
        prevEl: '.restaurants__carousel-btn--prev',
      },
      breakpoints: {
        479: {
          centeredSlides: false,
          spaceBetween: 10,
          slidesPerView: 2,
        },
        767: {
          centeredSlides: false,
          spaceBetween: 10,
          slidesPerView: 3,
        },
        992: {
          slidesPerView: 4,
          spaceBetween: 40,
        },
      }
    });
  }


  if ($(".news__items--carousel").length) {
    // init of News carousel
    const swiper3 = new Swiper('.news__items--carousel', {
      loop: true,
      slidesPerView: 3,
      spaceBetween: 20,
      simulateTouch: false,
      init: false,
      speed: 800,
      navigation: {
        nextEl: '.news__nav-btn--next',
        prevEl: '.news__nav-btn--prev',
      },
      breakpoints: {
        992: {
          slidesPerView: 3,
          spaceBetween: 40,
        },
      }
    });

    function initNewsSlider() {
      if ($(window).width() > 767) {
        swiper3.init();
      }
    }

    $(window).on('resize', initNewsSlider)

    initNewsSlider();
  }

  if ($(".shops__items--carousel").length) {
    // init of Shops carousel
    const swiper4 = new Swiper('.shops__items--carousel', {
      loop: true,
      slidesPerView: 3,
      spaceBetween: 20,
      simulateTouch: false,
      init: false,
      speed: 800,
      navigation: {
        nextEl: '.shops__nav-btn--next',
        prevEl: '.shops__nav-btn--prev',
      },
      breakpoints: {
        992: {
          slidesPerView: 4,
          spaceBetween: 40,
        },
      }
    });

    function initShopsSlider() {
      if ($(window).width() > 767) {
        swiper4.init();
      }
    }

    $(window).on('resize', initShopsSlider)

    initShopsSlider();
  }

  if ($(".gallery").length) {
    // init of Gallery carousel
    const swiper5 = new Swiper('.gallery', {
      loop: true,
      slidesPerView: 1,
      spaceBetween: 0,
      simulateTouch: false,
      speed: 800,
      navigation: {
        nextEl: '.gallery__nav-btn--next',
        prevEl: '.gallery__nav-btn--prev',
      },
      breakpoints: {
        767: {
          init: false,
        },
      }
    });

    function initGallerySlider() {
      if ($(window).width() < 768) {
        swiper5.init();
      } else {
        swiper5.destroy();
      }
    }

    $(window).on('resize', initGallerySlider)

    initGallerySlider();

    let gallery = new SimpleLightbox('.gallery__item');
  }

  $('body').on('click', '.js-avs-toggle', function (e) {
    e.preventDefault();
    let currentEl = $(this), parentEl = currentEl.closest('.avs__list');

    if (currentEl.hasClass('state-active')) {
      currentEl.next().slideUp();
      currentEl.removeClass('state-active');
    } else {
      parentEl.find('.state-active').removeClass('state-active');
      currentEl.addClass('state-active');
      parentEl.find('.avs__toggle-content').slideUp();
      currentEl.next().slideDown();
    }
  })

  $(".js-nav-toggle").on('click', function (e) {
    e.preventDefault();

    $(this).toggleClass('state-active');
    $(".header__nav").toggleClass('state-active');
  })


  let $body = $('body');

  // events on body
  $body
    .addClass('loaded')
    .on('click', '.js-social--auth', function (e) {
      // авторизация через социалки
      e.preventDefault();

      let href = $(this).attr('href') || $(this).attr('data-href');
      window.open(href, '', 'toolbar=0,status=0,width=626,height=436')
    })
    .on('click', '*[data-gtagcategory]', function (e) {
      // gtag
      var data = $(this).data();
      if (typeof gtag === 'undefined') {
        return false;
      }
      gtag('event', 'click', {
        'event_category': data.gtagcategory,
        'event_label': data.gtaglabel
      });
    });

  // подтверждение аккаунта
  (function () {
    let confirmed = coreFunctions.getParameterByName("confirmed");
    if (confirmed !== '') {
      window.setTimeout(function () {
        $('#modal--registration-congratulation').modal('show');
        coreFunctions.setHistoryState(document.title, "/");
      }, 50);
    }
  })();

  // inputmask
  $('input[data-mask]').each(function () {
    var $t = $(this), mask = $t.data('mask');
    if (typeof $t.attr('disabled') === 'undefined') {
      $t.inputmask('remove').inputmask('' + mask);
    }
  });

  $('input[data-name]').keypress(function(e) {
    let verified = String.fromCharCode(e.which).match(/^[абвгдеёжзийклмнопрстуфхцчшщьыъэюяАБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЬЫЪЭЮЯ-\s]*$/);
    if (verified === null) {
      e.preventDefault();
    }
  });

  // scroll
  $('.js--scroll').on('click', function () {
    $('html, body').animate({
      scrollTop: $($(this).attr('href')).offset().top
    }, 400);
    return false
  });

  // datepicker
  $.datepicker.regional['ru'] = {
    closeText: 'Закрыть',
    prevText: 'Предыдущий',
    nextText: 'Следующий',
    currentText: 'Сегодня',
    monthNames: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
    monthNamesShort: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
    dayNames: ['воскресенье', 'понедельник', 'вторник', 'среда', 'четверг', 'пятница', 'суббота'],
    dayNamesShort: ['вск', 'пнд', 'втр', 'срд', 'чтв', 'птн', 'сбт'],
    dayNamesMin: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
    weekHeader: 'Не',
    dateFormat: 'dd.mm.yy',
    firstDay: 1,
    isRTL: false,
    changeMonth: true,
    changeYear: true,
    showMonthAfterYear: false,
    yearSuffix: ''
  };
  $.datepicker.setDefaults($.datepicker.regional['ru']);
  $('.datepicker').each(function () {
    let $t = $(this);
    $t.datepicker({
      yearRange: $t.attr('data-year-range')
    });
  });

  // message
  window.showBootstrapMessage = function (params) {
    params = $.extend({
      title: '',
      message: ''
    }, params);

    let $v_modal = $('.modal:visible'),
      $m_modal = $('#modal-message'), $title = $m_modal.find('.modal-title'), $message = $m_modal.find('.modal-body');

    if ($m_modal.length < 1) {
      alert(params.title + '\n\n' + params.message);
      return;
    }

    $v_modal.modal('hide');
    $('.modal-backdrop').remove();

    $title.html(params.title);
    $message.html('<p>' + params.message + '</p>');

    $m_modal.modal('show');

    if (typeof params['afterHide'] === 'function') {
      $m_modal.on('hidden.bs.modal', function () {
        $m_modal.off('hidden.bs.modal');
        params.afterHide.call();
      });
    }
  };

  // modal
  window.showBootstrapModal = function (selector, params) {
    params = $.extend({
      afterHide: null
    }, params);

    let $v_modal = $('.modal:visible'), $m_modal = $(selector);

    $v_modal.modal('hide');
    $('.modal-backdrop').remove();

    $m_modal.modal('show');

    if (typeof params['afterHide'] === 'function') {
      $m_modal.on('hidden.bs.modal', function () {
        $m_modal.off('hidden.bs.modal');
        params.afterHide.call();
      });
    }
  };

  $(".header__burger, .header__nav-close").on('click', function () {
    $('body').toggleClass('show-nav');
  });

  // infinite scroll
  $(window).bind("scroll.paginator", function () {
    // Подгрузка работ при скролле
    let $paginator = $(".js--paginator__next--page"), $t = $(this), __delta = $(window).height(),
      __key = ".block.paginator.inAction";

    if (!$paginator.length) {
      return false;
    }
    if ($paginator.is(":visible")) {
      $paginator.hide();
    }
    if (typeof $t.data(__key) === "undefined") {
      $t.data(__key, false);
    }
    if ($t.data(__key) === true) {
      return false;
    }
    if ($t.scrollTop() >= ($(document).height() - $t.height() - __delta) && !$t.data(__key)) {
      $t.data(__key, true);
      return $paginator.find('a').trigger("click");
    }
  });

  window.preloadImages = function (images, callback) {
    let count = images.length, loaded = 0;
    if (count === 0) {
      callback();
    }
    $.each(images, function (index, image) {
      $('<img>').attr('src', image).on('load', function () { // the first argument could also be 'load error abort' if you wanted to *always* execute the callback
        loaded++;
        if (loaded === count) {
          callback();
        }
      });
    });
  };

  // @todo: дальше кодим!
  //alert(1);
});
